import { Box, Button, Flex, Text, VStack } from '@chakra-ui/react'
import { Google, Microsoft } from '@components/icons'
import React from 'react'

interface SocialAuthButtonsProps {
  onGoogleAuth: () => void
  onMicrosoftAuth: () => void
  isLoading?: boolean
  showDivider?: boolean
  [key: string]: any
}

export const SocialAuthButtons: React.FC<SocialAuthButtonsProps> = ({
  onGoogleAuth,
  onMicrosoftAuth,
  isLoading = false,
  showDivider = true,
  ...props
}) => {
  return (
    <VStack spacing={4} w="100%" {...props}>
      {showDivider && (
        <Flex align="center" w="100%">
          <Box flex="1" h="1px" bg="gray.200" />
          <Text px={3} fontSize="sm" color="gray.500">
            or
          </Text>
          <Box flex="1" h="1px" bg="gray.200" />
        </Flex>
      )}

      <Button
        size="lg"
        isFullWidth
        variant="outline"
        leftIcon={<Google size="20px" />}
        onClick={onGoogleAuth}
        isDisabled={isLoading}
        borderColor="#373C4123"
        _hover={{
          textDecoration: 'none',
          bg: 'rgb(238 240 253)'
        }}
      >
        Continue with Google
      </Button>

      <Button
        size="lg"
        isFullWidth
        variant="outline"
        leftIcon={<Microsoft size="20px" />}
        onClick={onMicrosoftAuth}
        isDisabled={isLoading}
        borderColor="#373C4123"
        _hover={{
          textDecoration: 'none',
          bg: 'rgb(238 240 253)'
        }}
      >
        Continue with Microsoft
      </Button>
    </VStack>
  )
}
